import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminDiscountsTableColumns";
import moment from "moment-jalaali";
import DeleteDiscount from "@general/deleteDiscount";

function AdminDiscountsTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onDataUpdate,
}) {
  const [tableData, setTableData] = useState([]);
  const { getDiscountsCount: count, getDiscounts: discounts } = data;



  useEffect(() => {
    const initialTableData = [];
    discounts.map((discount) => {
      const {
        id,
        createdAt,
        updatedAt,
        percent,
        maxCount,
        useCount,
        title,
        code,
        expiresAt,
        productIds,
        userIds,
      } = discount;
      initialTableData.push({
        key: id,
        updatedAt: moment(updatedAt).format("jYYYY/jMM/jDD"),
        expiresAt: moment(expiresAt).format("jYYYY/jMM/jDD"),
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        percent: percent + "%",
        count: `${useCount} از ${maxCount}`,
        title,
        code,
        productIds,
        userIds,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id)}>
              <EyeOutlined />
            </a>
            |
            <DeleteDiscount id={id} onDeleteDiscount={onDataUpdate}>
              <a>
                <DeleteOutlined />
              </a>
            </DeleteDiscount>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [discounts]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminDiscountsTable;
